import{registerRootComponent}from'expo';import'@finderau/nebula/fonts/fonts.css';import App from"./App.tsx";registerRootComponent(App);